module.exports = __webpack_public_path__ + "img/beauty-currency-guide.e9cdf254.png";